import $ from 'jquery';
import '../vendors/slick';

$( '.eb-js-featured-content-video-slider' ).slick( {
	arrows: false,
	fade: true,
	adaptiveHeight: true,
	asNavFor: '.eb-js-featured-content-thumbs-slider',
} );

$( '.eb-js-featured-content-thumbs-slider' ).slick( {
	arrows: false,
	slidesToShow: 4,
	focusOnSelect: true,
	asNavFor: '.eb-js-featured-content-video-slider',
} );
